var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_511_721)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2456 0.499756C8.70086 0.500898 7.45071 1.75448 7.45186 3.29918C7.45071 4.8439 8.702 6.09746 10.2467 6.09861H13.0416V3.30032C13.0427 1.75562 11.7914 0.502039 10.2456 0.499756C10.2467 0.499756 10.2467 0.499756 10.2456 0.499756ZM10.2456 7.96641H2.79489C1.25019 7.96756 -0.00110806 9.22114 3.36377e-05 10.7658C-0.00224975 12.3106 1.24904 13.5641 2.79375 13.5664H10.2456C11.7903 13.5653 13.0416 12.3117 13.0404 10.767C13.0416 9.22114 11.7903 7.96756 10.2456 7.96641Z",
    fill: "#36C5F0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9441 10.7658C27.9453 9.22114 26.694 7.96756 25.1492 7.96641C23.6045 7.96756 22.3532 9.22114 22.3544 10.7658V13.5664H25.1492C26.694 13.5653 27.9453 12.3117 27.9441 10.7658ZM20.4923 10.7658V3.29918C20.4934 1.75562 19.2433 0.502039 17.6986 0.499756C16.1539 0.500898 14.9026 1.75448 14.9037 3.29918V10.7658C14.9014 12.3106 16.1527 13.5641 17.6974 13.5664C19.2421 13.5653 20.4934 12.3117 20.4923 10.7658Z",
    fill: "#2EB67D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6974 28.4997C19.2421 28.4985 20.4934 27.245 20.4923 25.7002C20.4934 24.1555 19.2421 22.902 17.6974 22.9008H14.9025V25.7002C14.9014 27.2438 16.1527 28.4974 17.6974 28.4997ZM17.6974 21.0319H25.1492C26.6939 21.0307 27.9452 19.7771 27.9441 18.2324C27.9464 16.6877 26.6951 15.4342 25.1504 15.4319H17.6985C16.1538 15.433 14.9025 16.6866 14.9037 18.2313C14.9025 19.7771 16.1527 21.0307 17.6974 21.0319Z",
    fill: "#ECB22E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.18158e-05 18.2325C-0.00107988 19.7772 1.25021 21.0308 2.79492 21.032C4.33963 21.0308 5.59093 19.7772 5.58978 18.2325V15.4331H2.79492C1.25021 15.4343 -0.00107988 16.6878 6.18158e-05 18.2325ZM7.45189 18.2325V25.6992C7.44959 27.2439 8.70089 28.4975 10.2456 28.4998C11.7903 28.4986 13.0416 27.245 13.0405 25.7003V18.2348C13.0427 16.6901 11.7914 15.4365 10.2467 15.4343C8.70089 15.4343 7.45074 16.6878 7.45189 18.2325Z",
    fill: "#E01E5A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_511_721"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlack);
export default __webpack_public_path__ + "static/media/slack.2e720507cadcb6b10d73a099f64579ad.svg";
export { ForwardRef as ReactComponent };